import React, { useState, useEffect } from 'react';
import {  FormControl, InputLabel, MenuItem,  Select, Stack } from "@mui/material";
import NodeScriptTaskCamel from './NodeScriptTaskCamel';

const NodeScriptTaskRoot = React.forwardRef((props, ref) => {
    // export default function RootServiceTask(props) {
    const { item, processo, onClose } = props;
    const childRef = React.useRef();
    
    const [tipo, setTipo] = React.useState('');
    const [task, setTask] = React.useState();

    React.useImperativeHandle(ref, () => ({
        childMethod() {
            salva();
        }
    }));
    useEffect(() => {
        if (item && processo) {
            const t = processo.lstTask.find((i) => i.idTask === item.id);
            if (t) {                
                setTipo(t.tipo);
                setTask(t);
            }
        }
    }, [])

    function salva() {
        if (childRef && childRef.current) childRef.current.childMethod();
    }

    function montaFilho() {
        switch (tipo) {
            case 'CAMEL': return (<NodeScriptTaskCamel ref={childRef} item={item} processo={processo} onClose={onClose} tipo={tipo} task={task} />); break
            case 'SHELL': return (<h2>não implementado</h2>); break
        }
        return (
            <h2>Escolha um script apropriado</h2>
        )
    }
    function isJaEscolhido(){
        return tipo.length > 3;
    }
    return (
        <Stack style={{ width: '100%' }}>
            {/* <Box sx={{ minWidth: 220 }}> */}
            {!isJaEscolhido() && 
            <Stack direction="row" spacing={0} id='editor_tool'>
                <FormControl size='small' sx={{ minWidth: 220 }}>
                    <InputLabel id="demo-simple-select-label">Escolha o codigo do script</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={tipo}
                        label="Escola a classe de negocio"
                        onChange={(e) => setTipo(e.target.value)}
                    >
                        <MenuItem value={''}></MenuItem>
                        <MenuItem value={'CAMEL'}>Camel Script</MenuItem>
                        <MenuItem value={'SHELL'}>Shell Script</MenuItem>

                    </Select>
                </FormControl>                
            </Stack>}
            {/* </Box> */}
            {montaFilho()}            
        </Stack>
    )
})


export default NodeScriptTaskRoot;
